import { render, staticRenderFns } from "./vieMoreReports.vue?vue&type=template&id=3fff3cb4"
import script from "./vieMoreReports.vue?vue&type=script&lang=js"
export * from "./vieMoreReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports